import { EmotionDetectorScreens } from '../EmotionDetectorContextProvider/types';

export const emotionDetectorScreens: EmotionDetectorScreens = {
	signup: {
		componentName: 'SignupScreen',
		analyticsName: 'Emotion Detector Signup',
	},
	home: {
		componentName: 'HomeScreen',
		analyticsName: 'Emotion Detector Home',
	},
	camera: {
		componentName: 'CameraScreen',
		analyticsName: 'Emotion Detector Camera',
	},
	log: {
		componentName: 'LogScreen',
		analyticsName: 'Emotion Detector Log',
	},
};
